'use client'

import { PointsContainer } from '@/features/points/PointsContainer'

export default function PointsPage() {
  return <PointsContainer />
}
